import React from 'react';
import SEO from '../components/SEO';
import CoursePage from '../components/CoursePage';
import { smmData } from '../static/data';
import img from '../images/we3_social_media_marketing.png';

const SocialMediaMarketing = (props) => (
  <>
    <SEO
      title="WE3 Academy | Social Media Marketing Course | In Mumbai"
      description="Master the art of Social Media Marketing with our in-person training course designed to give you hands-on practical experience of running and managing social media accounts for your own or other businesses."
      keywords="WE3 Academy, WE3, social media marketing, social marketing, social media, social media marketing skills, digital marketing social media, best social media marketing courses, digital and social media marketing, social media management course, learn social media marketing, social media marketing training courses, social media marketing training, the social media, social network marketing, social media management, smm marketing, social media courses, social media skills, social media skills training, social media training, social media training course, social media marketing course in mumbai,"
      link="/social-media-marketing-course"
      img={img}
    >
      <script type="application/ld+json">
        {`
        {
          "@context" : "http://schema.org",
          "@type" : "Course",
          "name" : "Social Media Marketing Course",
          "description" : "Master the art of Social Media Marketing in 5 weekends with our in-person social media marketing course training in Mumbai, India.",
          "url" : "https://we3academy.com/social-media-marketing-course#curriculum"
        }
        `}
      </script>
    </SEO>
    <CoursePage {...props} scrollMax={3800} data={smmData} />
  </>
);

export default SocialMediaMarketing;
